import {
  FileSearchOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined
} from '@ant-design/icons'
import {
  Button,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Space,
  Switch,
  Tooltip,
  Upload,
  Empty
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import InputField from '../common/Input/InputField'
import ModalCustom from '../common/Modal/ModalCustom'
import SelectField from '../common/Select/SelectField'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  POLICY_DOCUMENT,
  PROCCESS_TRANFER,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
import ManagementPost from './ManagePost'
import Note from './Note'
import styles from './styles.module.scss'
import openNotification from '../common/Notification/openNotification '
import { getListUserDepartment, listUserPost } from '../../services/postservice'
import { formatCurrencyLabel, removeVietnameseTones } from '../../config-func'
import { columnLabel } from '../RequestInternal/configs'
import { useWatch } from 'antd/es/form/Form'
const MAX_SIZE_MB = 50 // Giới hạn dung lượng (MB)

// const formatCurrencyLabel = (value) => {
//   const num = parseInt(value, 10);
//   if (isNaN(num)) return '';
//   if (num >= 1_000_000_000) return `(${Math.round(num / 1_000_000_000)} tỉ)`;
//   if (num >= 1_000_000) return `(${Math.round(num / 1_000_000)} triệu)`;
//   if (num >= 1_000) return `(${Math.round(num / 1_000)} nghìn)`;
//   return `(${num})`;
// };

const FormPost = ({
  form,
  handleSearch,
  listDepartment,
  listUser,
  LabelType,
  ProductType,
  typeRealEstate,
  listProject,
  cities,
  districts,
  towns,
  postType,
  fileList,
  handleCustomRequest,
  handleChange,
  handlePreview,
  previewVisible,
  previewTitle,
  handleCancel,
  onChangeProject,
  previewImage,
  onChangePostType,
  onChangeCity,
  onChangeDistrict,
  fileListVideo,
  fileList360,
  onChangeDepartment,
  totalSize,
  mode,
  handleChange360,
  setFileList360,
  isText,
  setIsText,
  getListPost,
  recordId
}) => {
  const [isModalManagerPost, setIsModalManagerPost] = useState(false)
  const labelCheck = useWatch('label', form)
  const [costLabel, setCostLabel] = useState('')
  const [priceLabel, setPriceLabel] = useState('')

  const UploadButton = () => {
    return (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  const beforeUploadImage = (file) => {
    const isAllowedType = ['image/jpeg', 'image/png', 'image/gif'].includes(
      file.type
    )
    if (!isAllowedType) {
      openNotification('error', 'Chỉ hỗ trợ định dạng JPG, PNG, GIF!')
      return Upload.LIST_IGNORE
    }

    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      openNotification('error', 'Dung lượng file phải nhỏ hơn 100MB!')
      return Upload.LIST_IGNORE
    }

    return new Promise((resolve) => {
      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.onload = () => {
        if (img.width >= 300 && img.height >= 300) {
          resolve(true)
        } else {
          openNotification(
            'error',
            'Kích thước ảnh tối thiểu phải là 300x300px!'
          )
          resolve(Upload.LIST_IGNORE)
        }
      }
    })
  }

  const beforeUpload = (file) => {
    const isVideo = file.type.startsWith('video/')
    const isLt100MB = file.size / 1024 / 1024 < 100 // Giới hạn 100MB

    if (!isVideo) {
      openNotification('error', 'Chỉ được phép tải lên video!')
      return Upload.LIST_IGNORE
    }

    if (!isLt100MB) {
      openNotification('error', 'Video không được vượt quá 100MB!')
      return Upload.LIST_IGNORE
    }
    return true
  }

  // const [isText, setIsText] = useState(true) // Chuyển giữa text và ảnh

  const [loading, setLoading] = useState(false)
  const [managers, setManagers] = useState([
    // { id: 2116, name: 'Lê Văn Dương', phone: '0971516193' }
  ])

  const [managersAdd, setManagersAdd] = useState([])
  const getListUserPost = async (id) => {
    setLoading(true)
    try {
      const res = await listUserPost(id)
      if (res?.data) {
        setManagers(res?.data?.list)
        const assignerNames = res?.data?.list
          .map((item) => item.manager_post_info?.name)
          .filter(Boolean) // Lọc bỏ các giá trị null hoặc undefined
          .join(', ')

        // Set giá trị vào form
        form.setFieldsValue({ manager_post_id: assignerNames })
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  const getUserDepartment = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListUserDepartment(body) // Assuming roleSearch is an API function
      if (res && res.data.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setManagersAdd(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setManagersAdd([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      console.error('Error fetching roles:', err)
      // You might want to show a notification or alert to the user here
      setManagersAdd([]) // Optionally, reset the list to an empty array
    }
  }
  //   Chờ api
  useEffect(() => {
    const department_id = localStorage.getItem('department_id')
    if (mode == 'ADD') {
      // getUserDepartment(department_id)
    } else {
      // getListUserPost(recordId)
    }
  }, [])
  // const onChangeDepartment = async (value) => {
  //   await getUserDepartment(value)
  // }

  // useEffect(() => {
  //   if (mode !== 'ADD') {
  //     getListUserPost(form.getFieldValue('id'))
  //   }
  // }, [form.getFieldValue('id')])

  const handleProjectSelect = (project) => {
    form.setFieldsValue({
      project_id: project.value
    })
    onChangeProject(project.value)
  }

  const selectRef = useRef()

  const closeDropdown = () => {
    if (selectRef.current) {
      selectRef.current.blur() // This closes the dropdown
    }
  }

  // const handleLabelChange = (value) => {
  //     form.setFieldsValue({ label: value })
  //     // updateTitle()
  //   }

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSearch}
        // labelCol={{ span: 8 }}
        labelAlign="right"
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        onValuesChange={(value, allValues) =>
          console.log('vaaaaaa', value, allValues)
        }
        // initialValues={{ img360: [''] }}
      >
        <div className={styles.formAdd}>
          <Form.Item label="" name="id" style={{ display: 'none' }}>
            <Input />
          </Form.Item>

          <SelectField
            label="Sàn"
            name="department_id"
            required={true}
            options={listDepartment}
            onChange={(e) => {
              onChangeDepartment(e)
              getUserDepartment(e)
            }}
            style={{ width: '100%' }}
          />
          {mode == 'ADD' ? (
            <SelectField
              label="Quản lý tin"
              name="manager_post_id"
              mode="multiple"
              options={managersAdd}
              maxTagCount="responsive"
              // onChange={onChangeDepartment}
            />
          ) : (
            <Form.Item
              label={<div>Quản lý tin </div>}
              name=""
              style={{ marginBottom: 0 }}
              className={styles.formItem}
              // wrapperCol={{ span: 16 }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '5px',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <Form.Item
                  label=""
                  name="manager_post_id"
                  style={{ width: '100%' }}
                >
                  <Input style={{ width: '100%', color: '#000' }} disabled />
                </Form.Item>
                <Tooltip title="Thêm quản lý tin">
                  <FileSearchOutlined
                    onClick={() => {
                      setIsModalManagerPost(true)
                    }}
                    style={{
                      fontSize: '26px',
                      cursor: 'pointer',
                      color: '#7a7a7a',
                      marginTop: '3px'
                    }}
                  />
                </Tooltip>
              </div>
            </Form.Item>
          )}
          <SelectField
            label="Nhu cầu"
            name="label"
            required={true}
            options={columnLabel}
            placeholder="Chọn nhu cầu"
            //   onChange={handleLabelChange}
          />
          <SelectField
            label="Loại BĐS"
            name="post_type"
            required={true}
            options={ProductType}
            onChange={onChangePostType}
          />
          <SelectField
            label="Loại hình BĐS"
            name="type_real_estate"
            required={true}
            options={typeRealEstate}
          />
          {/* <SelectField
                ref={selectRef}
                label=
                  {postType === 2
                    ? 'Tên dự án Tòa nhà (Nếu có)'
                    : postType === 4
                    ? 'Tên dự án Đất nền (Nếu có)'
                    : postType === 3
                    ? 'Tên dự án Nhà đất (Nếu có)'
                    : (
                      <span>
                        <span style={{ color: 'red' }}>* </span>
                        Tên dự án
                      </span>
                    )
                  }
                
              name="project_id"
              rules={[
                {
                  required: postType === 1,
                  message: 'Vui lòng chọn dự án'
                }
              ]}
              onChange={(e) => onChangeProject(e)}
              options={listProject}
              showSearch
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              notFoundContent={
                postType === 1 ? (
                  <div style={{ padding: '0px' }}>
                    {listProject.find(
                      (project) => project.label.toLowerCase() === 'dự án khác'
                    ) && (
                      <div
                        className={styles.otherProjectOption}
                        onClick={() => {
                          const otherProject = listProject.find(
                            (project) =>
                              project.label.toLowerCase() === 'dự án khác'
                          )
                          if (otherProject) {
                            handleProjectSelect(otherProject)
                            closeDropdown() // Close the dropdown after selection
                          }
                        }}
                      >
                        Dự án khác
                      </div>
                    )}
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No data"
                    style={{ padding: '0px' }}
                  />
                )
              }
            /> */}
          <Form.Item
            label={
              postType === 2
                ? 'Tên dự án Tòa nhà (Nếu có)'
                : postType === 4
                ? 'Tên dự án Đất nền (Nếu có)'
                : postType === 3
                ? 'Tên dự án Nhà đất (Nếu có)'
                : 'Dự án'
            }
            name="project_id"
            rules={[
              {
                required: postType === 1,
                message: 'Vui lòng chọn dự án'
              }
            ]}
            className={styles.formItem}
          >
            <Select
              ref={selectRef}
              showSearch
              onChange={onChangeProject}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              placeholder="Chọn dự án"
              notFoundContent={
                postType === 1 ? (
                  <div style={{ padding: '0px' }}>
                    {listProject.find(
                      (project) => project.label.toLowerCase() === 'dự án khác'
                    ) && (
                      <div
                        className={styles.otherProjectOption}
                        onClick={() => {
                          const otherProject = listProject.find(
                            (project) =>
                              project.label.toLowerCase() === 'dự án khác'
                          )
                          if (otherProject) {
                            handleProjectSelect(otherProject)
                            closeDropdown()
                          }
                        }}
                      >
                        Dự án khác
                      </div>
                    )}
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No data"
                    style={{ padding: '0px' }}
                  />
                )
              }
            >
              {listProject.map((project) => (
                <Option key={project.value} value={project.value}>
                  {project.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <SelectField
            label="Tỉnh/Thành phố"
            name="city_code"
            required={true}
            onChange={onChangeCity}
            options={cities}
          />
          <SelectField
            label="Quận/Huyện"
            name="district_code"
            required={true}
            onChange={onChangeDistrict}
            options={districts}
          />
          <SelectField
            label={`Phường/Xã`}
            name="town_code"
            required={true}
            options={towns}
          />

          <InputField label="Đường phố" name="street" form={form} />

          {postType === 1 && [1, 2].includes(labelCheck) && (
            <InputField label="Mã căn hộ" name="apartment_code" form={form} />
          )}
          {postType === 1 && [1, 2].includes(labelCheck) && (
            <InputField label="Toà/Khu" name="building" form={form} />
          )}
          {postType === 1 && [1, 2].includes(labelCheck) && (
            <Form.Item
              label="Tầng/Dãy"
              name="floor"
              className={styles.formItem}
            >
              <Input
                placeholder="Nhập tầng/dãy"
                onChange={(e) => {
                  let value = e.target.value

                  // Chuyển dấu "," thành "."
                  value = value.replace(/,/g, '.')

                  // Không cho số 0 đứng đầu nếu sau đó là số khác (không chặn '0' một mình)
                  value = value.replace(/^0+([1-9])/, '$1')

                  // Giữ lại chữ cái, số, dấu . và dấu -
                  value = value.replace(/[^a-zA-Z0-9\.\-]/g, '')

                  form.setFieldsValue({ floor: value })
                }}
              />
            </Form.Item>

            // <InputField label="Tầng/Dãy" name="floor" form={form} />
          )}
          {postType === 1 && [1, 2].includes(labelCheck) && (
            // <InputField label="Số căn" name="number_of_rooms" form={form} />
            <Form.Item
              label="Số căn"
              name="number_of_rooms"
              className={styles.formItem}
            >
              <Input
                placeholder="Nhập số căn"
                onChange={(e) => {
                  let value = e.target.value

                  // Chuyển dấu "," thành "."
                  value = value.replace(/,/g, '.')

                  // Không cho số 0 đứng đầu nếu sau đó là số khác (không chặn '0' một mình)
                  value = value.replace(/^0+([1-9])/, '$1')

                  // Giữ lại chữ cái, số, dấu . và dấu -
                  value = value.replace(/[^a-zA-Z0-9\.\-]/g, '')

                  form.setFieldsValue({ number_of_rooms: value })
                }}
              />
            </Form.Item>
          )}

          {!(postType === 1) && [1, 2].includes(labelCheck) && (
            <InputField label="Số địa chỉ" name="alley" form={form} />
          )}

          {postType === 1 && [3, 4].includes(labelCheck) ? (
            ''
          ) : (
            <Form.Item
              label="Diện tích (m2)"
              name="acreage"
              className={styles.formItem}
            >
              <InputNumber
                onBlur={(e) => {
                  const value = parseFloat(e.target.value?.trim())
                  form.setFields([
                    {
                      name: 'acreage',
                      value: isNaN(value) ? 0 : value
                    }
                  ])
                }}
                className={styles.InputNumber}
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
                placeholder="Nhập diện tích"
              />
            </Form.Item>
          )}

          {postType != 1 && (
            <Form.Item
              label="Mặt tiền (m)"
              name="area_outside"
              className={styles.formItem}
            >
              <InputNumber
                onBlur={(e) => {
                  const value = parseFloat(e.target.value?.trim())

                  form.setFields([
                    {
                      name: 'area_outside',
                      value: isNaN(value) ? 0 : value
                    }
                  ])
                }}
                className={styles.InputNumber}
                placeholder="Nhập kích thước"
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
              />
            </Form.Item>
          )}

          {(postType === 2 || postType === 3) && (
            // <InputField label="Số tầng" name="number_of_floor" form={form} />
            <Form.Item
              label="Số tầng"
              name="number_of_floor"
              className={styles.formItem}
            >
              <Input
                placeholder="Nhập số tầng"
                onChange={(e) => {
                  let value = e.target.value

                  // Chuyển dấu "," thành "."
                  value = value.replace(/,/g, '.')

                  // Không cho số 0 đứng đầu nếu sau đó là số khác (không chặn '0' một mình)
                  value = value.replace(/^0+([1-9])/, '$1')

                  // Giữ lại chữ cái, số, dấu . và dấu -
                  value = value.replace(/[^a-zA-Z0-9\.\-]/g, '')

                  form.setFieldsValue({ number_of_floor: value })
                }}
              />
            </Form.Item>
          )}

          {(postType === 1 || postType === 3) &&
            [1, 2].includes(labelCheck) && (
              <InputField
                label="Số phòng ngủ"
                name="number_of_bedrooms"
                form={form}
              />
            )}

          {postType === 3 && [1, 2].includes(labelCheck) && (
            <Form.Item
              label="Số WC"
              name="number_of_wc"
              className={styles.formItem}
            >
              <InputNumber
                // min={1}
                onBlur={(e) => {
                  form.setFields([
                    {
                      name: 'number_of_wc',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
                className={styles.InputNumber}
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
                placeholder="Nhập số WC"
              />
            </Form.Item>
          )}

          <SelectField
            label="Vị trí"
            name="apartment_location"
            options={APARTMENT_TYPE}
          />

          <SelectField
            label="Hướng"
            name="direction"
            options={BALCONY_DIRECTION}
          />
          {[1, 2].includes(labelCheck) && (
            <SelectField
              label="Giấy tờ pháp lý"
              name="legal"
              options={POLICY_DOCUMENT}
            />
          )}

          <Form.Item
            label={`Giá: ${formatCurrencyLabel(
              String(form.getFieldValue('price'))?.replaceAll('.', '')
            )}`}
            name="price"
            className={styles.formItem}
          >
            <InputNumber
              placeholder="Nhập giá"
              onBlur={() => {
                const rawValue = form.getFieldValue('price')
                form.setFields([
                  {
                    name: 'price',
                    value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                  }
                ])
              }}
              onChange={(value) => {
                setPriceLabel(formatCurrencyLabel(value))
              }}
              className={styles.InputNumber}
              formatter={(value) => {
                if (!value) return ''
                return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              }}
              parser={(value) => (value ? value.replace(/\./g, '') : '')}
              maxLength={255}
            />
          </Form.Item>
          {[1, 2].includes(labelCheck) && (
            <Form.Item
              label={`Phí môi giới:  ${formatCurrencyLabel(
                form.getFieldValue('cost')
              )}`}
              name="cost"
              className={styles.formItem}
            >
              <InputNumber
                placeholder="Nhập phí môi giới"
                onBlur={() => {
                  const rawValue = form.getFieldValue('cost')
                  form.setFields([
                    {
                      name: 'cost',
                      value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                    }
                  ])
                }}
                onChange={(value) => {
                  setCostLabel(formatCurrencyLabel(value))
                }}
                className={styles.InputNumber}
                formatter={(value) => {
                  if (!value) return ''
                  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }}
                parser={(value) => (value ? value.replace(/\./g, '') : '')}
                maxLength={255}
              />
            </Form.Item>
          )}

          {[1, 2].includes(labelCheck) && (
            <SelectField
              label="Phí giao dịch"
              name="procedure"
              options={PROCCESS_TRANFER}
            />
          )}
          {
            (postType = 4 && [1, 2].includes(labelCheck) && (
              <SelectField
                label="Nội thất"
                name="furniture"
                options={FURNITURE_TYPE}
              />
            ))
          }

          <SelectField label="Hiện trạng" name="status" options={status} />

          <Form.Item
            label="Trạng thái"
            name="processing_status"
            rules={[{ required: true, message: 'Vui lòng chọn trạng thái!' }]}
            className={styles.formItem}
          >
            <Select placeholder="Chọn trạng thái">
              {statusList.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {[1, 2].includes(labelCheck) && (
            <SelectField
              label="Bảo mật thông tin"
              name="security"
              options={SECURITY_TYPE}
              required={true}
            />
          )}
          <InputField
            label="Tên khách hàng"
            name="customer_name"
            form={form}
            rules={[
              { required: true, message: 'Vui lòng nhập tên khách hàng!' }
            ]}
          />
          <InputField
            label="Số điện thoại"
            name="customer_phone_number"
            form={form}
            rules={[
              {
                required: true,
                message: ''
              },
              {
                validator: (_, value) => {
                  if (!value || !value.trim()) {
                    return Promise.reject(
                      new Error('Vui lòng nhập số điện thoại !')
                    )
                  }

                  const phoneNumbers = value.split(/[,|-]/).map((p) => p.trim())
                  const invalidNumbers = phoneNumbers.filter(
                    (number) => !/^0\d{9}$/.test(number)
                  )

                  if (invalidNumbers.length > 0) {
                    return Promise.reject(
                      new Error(
                        'Mỗi số điện thoại phải có 10 chữ số và bắt đầu bằng 0. Phân tách bằng "," hoặc "-".'
                      )
                    )
                  }

                  return Promise.resolve()
                }
              }
            ]}
          />
        </div>

        <Form.Item label="Mô tả" name="description" className={styles.formFull}>
          <Input.TextArea
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'description',
                  value: e.target.value?.trim()
                }
              ])
            }}
            placeholder="Nhập mô tả"
            maxLength={255}
          />
        </Form.Item>

        {mode == 'ADD' && (
          <Form.Item label="Note" name="note" className={styles.formFull}>
            <Input.TextArea
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'note',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              placeholder="Nhập note"
              maxLength={255}
            />
          </Form.Item>
        )}
        {[1, 2].includes(labelCheck) && (
          <Form.Item
            label="Hình ảnh"
            name="image_urls"
            className={styles.formFull}
          >
            <Upload
              accept="image/*" // Chỉ cho phép upload file video
              beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
              customRequest={(options) => handleCustomRequest(options, 'image')} // Sử dụng custom request để gọi API của bạn
              onChange={(e) => {
                handleChange(e, 'image')
              }}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              multiple={true}
              maxCount={9}
            >
              {fileList.length < 9 && <UploadButton />}
            </Upload>
            <span style={{ fontWeight: 600, color: '#f54545', fontSize: 13 }}>
              *Note: Bạn chỉ chọn tối đa 9 file
            </span>

            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
            >
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
          </Form.Item>
        )}

        {[1, 2].includes(labelCheck) && (
          <Form.Item
            label="Video"
            name="video_urls"
            className={styles.formFull}
          >
            <Upload
              accept="video/*" // Chỉ cho phép upload file video
              beforeUpload={beforeUpload} // Kiểm tra trước khi upload
              customRequest={(options) => handleCustomRequest(options, 'video')} // Sử dụng custom request để gọi API của bạn
              onChange={(e) => {
                handleChange(e, 'video')
              }}
              //   listType="picture-card"
              // multiple={false}
              showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }} // Hiển thị danh sách file
              fileList={fileListVideo}
              // onPreview={handlePreview}
              // onChange={handleChange}
            >
              <Button
                disabled={
                  totalSize >= 100
                    ? true
                    : fileListVideo.length >= 3
                    ? true
                    : false
                }
                icon={<UploadOutlined />}
              >
                Chọn Video
              </Button>
            </Upload>
          </Form.Item>
        )}
        {[1, 2].includes(labelCheck) && (
          <>
            {isText ? (
              <Form.Item
                style={{ width: '100%' }}
                label={
                  <>
                    Hình ảnh 360
                    <Switch
                      checkedChildren="Link"
                      unCheckedChildren="360"
                      checked={isText}
                      onChange={() => {
                        setIsText(!isText)

                        setFileList360([])
                      }}
                      style={{ marginLeft: 10 }}
                    />
                  </>
                }
                className={styles.formFull}
              >
                <Form.List name="image_360">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <div
                          key={key}
                          style={{ display: 'flex', gap: 8, width: '100%' }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'url']}
                            style={{ flex: 1, marginBottom: 12 }} // Đảm bảo Input chiếm toàn bộ không gian
                          >
                            <Input
                              placeholder="Nhập link..."
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <MinusCircleOutlined
                            onClick={() => remove(name)}
                            style={{ color: 'red' }}
                          />
                        </div>
                      ))}

                      {fields.length < 3 && (
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          icon={<PlusOutlined />}
                          // style={{ width: '100%' }}
                        >
                          Thêm link
                        </Button>
                      )}
                    </>
                  )}
                </Form.List>
              </Form.Item>
            ) : (
              <Form.Item
                label={
                  <>
                    Hình ảnh 360
                    <Switch
                      checkedChildren="Link"
                      unCheckedChildren="360"
                      checked={isText}
                      onChange={() => {
                        setIsText(!isText)
                        form.setFieldsValue({ image_360: [''] })
                        setFileList360([])
                        // form.setFieldsValue({ image_360: [] })
                      }}
                      style={{ marginLeft: 10 }}
                    />
                  </>
                }
                name="img360"
                className={styles.formFull}
              >
                <Upload
                  // accept="image/*" // Chỉ cho phép upload file video
                  beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
                  customRequest={(options) =>
                    handleCustomRequest(options, '360')
                  } // Sử dụng custom request để gọi API của bạn
                  onChange={(e) => {
                    handleChange(e, '360')
                  }}
                  //   listType="picture-card"
                  multiple={false}
                  showUploadList={{
                    showPreviewIcon: false,
                    showRemoveIcon: true
                  }} // Hiển thị danh sách file
                  fileList={fileList360}
                  // onPreview={handlePreview}
                  // onChange={handleChange}
                >
                  <Button
                    disabled={
                      totalSize >= 100
                        ? true
                        : fileList360.length >= 3
                        ? true
                        : false
                    }
                    icon={<UploadOutlined />}
                  >
                    Chọn File 360
                  </Button>
                </Upload>
              </Form.Item>
            )}
          </>
        )}
        {/* <Form.Item label="Note" name="note" className={styles.formFull}>
          <Input.TextArea
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'note',
                  value: e.target.value?.trim()
                }
              ])
            }}
            placeholder="Nhập note"
            maxLength={255}
          />
        </Form.Item> */}
      </Form>
      {mode !== 'ADD' && <Note postId={form.getFieldValue('id')} />}
      {/* <Note postId={form.getFieldValue('id')}/> */}

      <ModalCustom
        title="Danh sách quản lý tin"
        visible={isModalManagerPost}
        centered
        width={600}
        onCancel={() => {
          setIsModalManagerPost(false)
          //   setFileList([])
        }}
        //  onConfirm={async () => {
        //    try {
        //     const a = "12,13,14,15,1qưdwqdwqdqwdqwqdwqdqwdqwdwqdwqdqqd6"
        //     form.setFieldsValue({
        //       manager_post_id: a,
        //     });
        //     //  await form.validateFields() // Kiểm tra validation trước khi tiếp tục
        //     //  handleImport() // Nếu hợp lệ thì tiếp tục xử lý
        //    } catch (error) {
        //      console.log('Validation failed:', error)
        //    }
        //  }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <ManagementPost
          getListPost={getListPost}
          postId={form.getFieldValue('id')}
          data={listUser}
          list={managers}
          loading={loading}
          setLoading={setLoading}
          getList={getListUserPost}
        />
      </ModalCustom>
    </>
  )
}

export default FormPost
